import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { machineryService } from '../../../services/machineryService';
import Toast from '../../../components/Common/Toast';

const CreateVehicle = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [toast, setToast] = useState({ isOpen: false, message: '', type: 'info' });
  const [formData, setFormData] = useState({
    code: '',
    name: '',
    brand: '',
    model: '',
    license_plate: '',
    year: new Date().getFullYear(),
    color: '',
    type: 'pickup',
    category_id: '',
    status: 'active',
    propio: 'propio',
    control_hour_meter: false,
    control_mileage: false,
    soat_expires_at: '',
    revision_tecnica_expires_at: '',
    notes: ''
  });

  useEffect(() => {
    const loadCategories = async () => {
      const res = await machineryService.getCategories({ scope: 'vehicle' });
      if (res.success && Array.isArray(res.data)) {
        setCategories(res.data);
      }
    };
    loadCategories();
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = {
        ...formData,
        year: parseInt(formData.year, 10) || new Date().getFullYear(),
        category_id: formData.category_id ? parseInt(formData.category_id, 10) : null,
        soat_expires_at: formData.soat_expires_at || null,
        revision_tecnica_expires_at: formData.revision_tecnica_expires_at || null,
      };
      const response = await machineryService.createVehicle(data);
      if (response.success) {
        setToast({ isOpen: true, message: 'Vehículo creado exitosamente', type: 'success' });
        setTimeout(() => navigate('/machinery/vehicles'), 1500);
      } else {
        setToast({ isOpen: true, message: response.message || 'Error al crear el vehículo', type: 'error' });
      }
    } catch (error) {
      setToast({ isOpen: true, message: 'Error al crear el vehículo', type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6">
      <div className="max-w-4xl mx-auto">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-800">Nuevo Vehículo</h1>
          <p className="text-gray-600 mt-1">Complete el formulario para registrar un nuevo vehículo</p>
        </div>
        <form onSubmit={handleSubmit} className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div><label className="block text-sm font-medium text-gray-700 mb-2">Código *</label>
              <input type="text" name="code" value={formData.code} onChange={handleChange} required className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500" placeholder="VEH-001" />
            </div>
            <div><label className="block text-sm font-medium text-gray-700 mb-2">Nombre *</label>
              <input type="text" name="name" value={formData.name} onChange={handleChange} required className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500" />
            </div>
            <div><label className="block text-sm font-medium text-gray-700 mb-2">Marca *</label>
              <input type="text" name="brand" value={formData.brand} onChange={handleChange} required className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500" />
            </div>
            <div><label className="block text-sm font-medium text-gray-700 mb-2">Modelo *</label>
              <input type="text" name="model" value={formData.model} onChange={handleChange} required className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500" />
            </div>
            <div><label className="block text-sm font-medium text-gray-700 mb-2">Placa *</label>
              <input type="text" name="license_plate" value={formData.license_plate} onChange={handleChange} required className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500" />
            </div>
            <div><label className="block text-sm font-medium text-gray-700 mb-2">Año</label>
              <input type="number" name="year" value={formData.year} onChange={handleChange} className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500" />
            </div>
            <div><label className="block text-sm font-medium text-gray-700 mb-2">Color</label>
              <input type="text" name="color" value={formData.color} onChange={handleChange} className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500" />
            </div>
            <div><label className="block text-sm font-medium text-gray-700 mb-2">Tipo *</label>
              <select name="type" value={formData.type} onChange={handleChange} required className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500">
                <option value="pickup">Pickup</option>
                <option value="volquete">Volquete</option>
                <option value="furgon">Furgón</option>
                <option value="camion">Camión</option>
                <option value="otro">Otro</option>
              </select>
            </div>
            <div><label className="block text-sm font-medium text-gray-700 mb-2">Categoría (opcional)</label>
              <select name="category_id" value={formData.category_id} onChange={handleChange} className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500">
                <option value="">Sin categoría</option>
                {categories.map((cat) => (
                  <option key={cat.id} value={cat.id}>{cat.name}</option>
                ))}
              </select>
            </div>
            <div><label className="block text-sm font-medium text-gray-700 mb-2">Estado *</label>
              <select name="status" value={formData.status} onChange={handleChange} required className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500">
                <option value="active">Activo</option>
                <option value="maintenance">En Mantenimiento</option>
                <option value="inactive">Inactivo</option>
                <option value="retired">Retirado</option>
              </select>
            </div>
            <div><label className="block text-sm font-medium text-gray-700 mb-2">¿Es propio? *</label>
              <select name="propio" value={formData.propio} onChange={handleChange} required className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500">
                <option value="propio">Propio</option>
                <option value="alquilado">Alquilado</option>
              </select>
            </div>
            <div className="md:col-span-2 border-t border-gray-200 pt-4">
              <label className="block text-sm font-medium text-gray-700 mb-2">Control de uso</label>
              <p className="text-sm text-gray-500 mb-3">Indique si se llevará control de horómetro y/o kilometraje para este vehículo (puede marcar ambos)</p>
              <div className="flex flex-wrap gap-6">
                <label className="inline-flex items-center gap-2 cursor-pointer">
                  <input type="checkbox" name="control_hour_meter" checked={!!formData.control_hour_meter} onChange={handleChange} className="w-4 h-4 rounded border-gray-300 text-teal-600 focus:ring-teal-500" />
                  <span className="text-sm text-gray-700">Controlar horómetro</span>
                </label>
                <label className="inline-flex items-center gap-2 cursor-pointer">
                  <input type="checkbox" name="control_mileage" checked={!!formData.control_mileage} onChange={handleChange} className="w-4 h-4 rounded border-gray-300 text-teal-600 focus:ring-teal-500" />
                  <span className="text-sm text-gray-700">Controlar kilometraje</span>
                </label>
              </div>
            </div>
            <div className="md:col-span-2 border-t border-gray-200 pt-4">
              <label className="block text-sm font-medium text-gray-700 mb-2">SOAT y revisión técnica</label>
              <p className="text-sm text-gray-500 mb-3">Opcional. El sistema alertará en el dashboard un mes antes del vencimiento.</p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">SOAT — fecha de vencimiento</label>
                  <input type="date" name="soat_expires_at" value={formData.soat_expires_at} onChange={handleChange} className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Revisión técnica — fecha de vencimiento</label>
                  <input type="date" name="revision_tecnica_expires_at" value={formData.revision_tecnica_expires_at} onChange={handleChange} className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500" />
                </div>
              </div>
            </div>
            <div className="md:col-span-2"><label className="block text-sm font-medium text-gray-700 mb-2">Notas</label>
              <textarea name="notes" value={formData.notes} onChange={handleChange} rows="3" className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500" />
            </div>
          </div>

          <div className="mt-6 flex gap-4">
            <button type="submit" disabled={loading} className="px-6 py-2.5 bg-teal-600 hover:bg-teal-700 disabled:bg-gray-400 text-white rounded-lg font-medium transition-colors">
              {loading ? 'Guardando...' : 'Guardar'}
            </button>
            <button type="button" onClick={() => navigate('/machinery/vehicles')} className="px-6 py-2.5 bg-gray-200 hover:bg-gray-300 text-gray-700 rounded-lg font-medium transition-colors">
              Cancelar
            </button>
          </div>
        </form>
      </div>
      <Toast isOpen={toast.isOpen} message={toast.message} type={toast.type} onClose={() => setToast({ ...toast, isOpen: false })} />
    </div>
  );
};

export default CreateVehicle;
